var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 20,
    height: 7,
    rx: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.5,
    r: 1,
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 6.5,
    x2: 18,
    y2: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 20,
    height: 7,
    rx: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 17.5,
    r: 1,
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 17.5,
    x2: 18,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11,
    r: 3.5,
    fill: "none",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 9.2,
    x2: 19,
    y2: 12.8,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.2,
    y1: 11,
    x2: 20.8,
    y2: 11,
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetOnboarding);
export default __webpack_public_path__ + "static/media/AssetOnboarding.cd9590eeb7a2afa279fb4bfc563de372.svg";
export { ForwardRef as ReactComponent };